// extracted by mini-css-extract-plugin
export default {"container":"CourierTasks_container__1o8v0","nav":"CourierTasks_nav__4xrf+","collapse":"CourierTasks_collapse__92zaj"};